import * as React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Footer from 'components/Footer'
import Header from 'components/Header'
import loginData from 'utilities/loginData'

/**
 * 画質エラー画面
 * 本人確認で画像の品質が不十分だった場合に表示される再撮影案内画面
 */
const IdentificationQualityError: React.FC = () => {
  const navigate = useNavigate()

  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    }
  }, [navigate])

  /**
   * 再撮影ボタンのハンドラー
   */
  const handleRetryButton = () => {
    const timestamp = new Date().toISOString()
    console.log(`[DEBUG ${timestamp}] Quality error retry button clicked`)
    
    // 元の本人確認画面に戻る
    navigate('/registerIdentificationForIndividual')
  }

  return (
    <>
      <Header title="証明書登録" />
      <main>
        <section className="mx-4 my-5">
          <div className="text-center mt-4">
            <div className="mb-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#FFC107',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto',
                  fontSize: '32px'
                }}
              >
                📸
              </div>
            </div>
            
            <h3 className="fw-bold mb-3">画像が不鮮明です</h3>
            <div className="note mb-4">
              <div>撮影された画像の品質が不十分なため、</div>
              <div>本人確認を完了できませんでした。</div>
            </div>
            
            <hr className="my-4" />
            
            <div className="text-start mb-4" style={{ maxWidth: '400px', margin: '0 auto' }}>
              <div className="font-15 fw-bold mb-3">撮影時のポイント</div>
              
              <div className="mb-3">
                <div className="d-flex align-items-start">
                  <span className="me-2">💡</span>
                  <div>
                    <div className="fw-bold">明るい場所で撮影</div>
                    <div className="note">十分な明るさのある場所で撮影してください</div>
                  </div>
                </div>
              </div>
              
              <div className="mb-3">
                <div className="d-flex align-items-start">
                  <span className="me-2">📱</span>
                  <div>
                    <div className="fw-bold">手ブレに注意</div>
                    <div className="note">スマートフォンをしっかり持って撮影してください</div>
                  </div>
                </div>
              </div>
              
              <div className="mb-3">
                <div className="d-flex align-items-start">
                  <span className="me-2">✨</span>
                  <div>
                    <div className="fw-bold">光の反射を避ける</div>
                    <div className="note">証明書に光が反射しないよう角度を調整してください</div>
                  </div>
                </div>
              </div>
              
              <div className="mb-3">
                <div className="d-flex align-items-start">
                  <span className="me-2">📄</span>
                  <div>
                    <div className="fw-bold">全体を画面に収める</div>
                    <div className="note">身分証明書の四隅が写るようにしてください</div>
                  </div>
                </div>
              </div>
            </div>
            
            <Button 
              variant="primary" 
              className="w-100 py-3 mb-3" 
              onClick={handleRetryButton}
            >
              もう一度撮影する
            </Button>
            
            <div className="note text-muted">
              <small>撮影がうまくいかない場合は、カスタマーサポートまでお問い合わせください。</small>
            </div>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default IdentificationQualityError